import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'

import { AmplifySignOut } from '@aws-amplify/ui-react';

import styles from './Navbar.module.css'; 
import logo from '../../assets/logo_full2x.png'

import * as AuthSelectors from '../../store/auth/selectors';


import {  Layout, Menu, Popover} from 'antd';
import {  UserOutlined } from '@ant-design/icons';
import {ADMIN_PROFILE, CLIENT_PROFILE} from '../../interfaces/auth.interface'

import { Link, useHistory, withRouter } from "react-router-dom";

const { Header } = Layout;

const ListMenu = ({pathname, pages}) => {
    const path = `/${pathname.split('/')[1]}`

    return <Menu mode="horizontal" selectedKeys={[path]}>
                {pages.map(page => (
                    <Menu.Item key={page.routeProps.path}>
                        <Link to={`${page.routeProps.path}`}>{page.name}</Link>
                    </Menu.Item>
                ))}
            </Menu>
}

const Navbar = () => {
    const userProfile = useSelector(AuthSelectors.selectUserProfile)
    const userEmail = useSelector(AuthSelectors.selectUserEmail)
    let {location:{pathname}} = useHistory();

    const [pages, setPages] = useState([])

    const loadModuleRoutes = async () => {
        switch (userProfile) {
            case CLIENT_PROFILE:
                const moduleClient = await import('../../modules/ClientApp/pages')
                setPages(moduleClient.default);
                break;
            case ADMIN_PROFILE:
                const moduleAdmin = await import('../../modules/AdminApp/pages')
                setPages(moduleAdmin.default);
                break;
            default:
        }
        
    }

    useEffect(() => {
        loadModuleRoutes()
    }, [userProfile]);

    

    return (
        <Header className={styles.navbar}>
            <img src={logo} alt="Logo Archicam" className={styles.logo} />
            <ListMenu profile={userProfile} pathname={pathname} pages={pages}/>
            <Popover placement="topLeft" title={userEmail} content={<AmplifySignOut buttonText="Выйти"></AmplifySignOut>} trigger="click">
                <UserOutlined  style={ { fontSize: 20, color: '#08c'} } />
            </Popover>
        </Header>)
}

export default withRouter(Navbar);